import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { AudioProvider, usePlayer } from "@/context/AudioContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { AudioPlayerBar } from "@/components/AudioPlayerBar";
import Home from "@/pages/Home";
import Vault from "@/pages/Vault";
import VaultDetail from "@/pages/VaultDetail";
import OfficialMusic from "@/pages/OfficialMusic";
import About from "@/pages/About";
import RoyalList from "@/pages/RoyalList";
import LegalPage from "@/pages/LegalPage";
import ArchiveLanding from "@/pages/ArchiveLanding";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PlayerSpacer = () => {
  const { track } = usePlayer();
  return track ? <div className="h-[76px]" /> : null;
};

const Shell = () => {
  const site = useSite();
  const { pathname } = useLocation();
  if (site.archive_mode === "on" && !pathname.startsWith("/admin")) {
    return <ArchiveLanding />;
  }
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/vault" element={<Vault />} />
          <Route path="/vault/:slug" element={<VaultDetail />} />
          <Route path="/official-music" element={<OfficialMusic />} />
          <Route path="/about" element={<About />} />
          <Route path="/royal-list" element={<RoyalList />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/privacy" element={<LegalPage kind="privacy" />} />
          <Route path="/terms" element={<LegalPage kind="terms" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      <Footer />
      <PlayerSpacer />
      <AudioPlayerBar />
    </>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="grain bg-obsidian min-h-screen text-cream">
      <BrowserRouter>
        <AuthProvider>
          <SiteProvider>
          <AudioProvider>
            <ScrollToTop />
            <Shell />
            <Toaster theme="dark" position="top-center" />
          </AudioProvider>
          </SiteProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
